module.exports = __webpack_public_path__ + "assets/ic_cart_x-caabe4.svg";